import Image from "next/image";

import type {
  SanityImageCrop,
  SanityImageHotspot,
  internalGroqTypeReferenceTo,
} from "@sorcery/cms";
import { cn } from "@sorcery/ui";
import { getSanityImageUrl } from "@sorcery/utils/client/sanity";

import { env } from "~/env";

type CoverImageProps = {
  slug: string;
  source: {
    _type: "image";
    asset?: {
      _ref: string;
      _type: "reference";
      _weak?: boolean;
      [internalGroqTypeReferenceTo]?: "sanity.imageAsset";
    };
    crop?: SanityImageCrop | undefined;
    hotspot?: SanityImageHotspot | undefined;
  };
  priority?: boolean;
};

export const PostHeroImage = (props: CoverImageProps) => {
  const { slug, source, priority } = props;
  const image = source?.asset?._ref ? (
    <div
      className={cn("shadow-small sorcery-wide-container", {
        "hover:shadow-medium transition-shadow duration-200": slug,
      })}
    >
      <Image
        width={2000}
        height={900}
        blurDataURL={getSanityImageUrl(
          source,
          env.NEXT_PUBLIC_SANITY_PROJECT_ID,
          env.NEXT_PUBLIC_SANITY_DATASET,
        )
          .width(24)
          .height(24)
          .blur(10)
          .url()}
        alt={"Cover Image"}
        src={getSanityImageUrl(
          source,
          env.NEXT_PUBLIC_SANITY_PROJECT_ID,
          env.NEXT_PUBLIC_SANITY_DATASET,
        )
          .width(2000)
          .height(900)
          .url()}
        priority={priority}
      />
    </div>
  ) : (
    <div style={{ paddingTop: "50%", backgroundColor: "#ddd" }} />
  );

  return <div className="sm:mx-0">{image}</div>;
};
